import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Spin, Typography, message } from 'antd';
import { CheckCircleOutlined, TeamOutlined } from '@ant-design/icons';
import { supabase } from '../utils/supabase';
import { shopTeamApi } from '../utils/api';

/** Accueille le destinataire du lien et l'ajoute à la boutique une fois connecté avec le bon e-mail. */
const TeamInvitation = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accepting, setAccepting] = useState(false);

  /** Récupère la session locale pour choisir entre l'authentification et l'acceptation de l'invitation. */
  useEffect(() => {
    let active = true;
    supabase.auth.getSession().then(({ data }) => { if (active) { setSession(data.session); setLoading(false); } });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, nextSession) => { if (active) setSession(nextSession); });
    return () => { active = false; subscription.unsubscribe(); };
  }, []);

  /** Accepte le lien avec le compte connecté, puis ouvre le sélecteur de boutique actualisé. */
  const accept = async () => {
    setAccepting(true);
    try {
      await shopTeamApi.acceptInvitation(token);
      message.success('Vous avez rejoint la boutique.');
      navigate('/app/select-shop', { replace: true });
    } catch (error) {
      message.error(error.response?.data?.error || 'Impossible d’accepter cette invitation.');
    } finally {
      setAccepting(false);
    }
  };

  const redirect = encodeURIComponent(`/team-invitations/${token}`);
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Spin size="large" /></div>;
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4"><Card className="w-full max-w-md text-center"><TeamOutlined className="text-4xl text-blue-600" /><Typography.Title level={2}>Invitation d’équipe</Typography.Title>{session ? <><Typography.Paragraph>Vous êtes connecté(e) avec <strong>{session.user.email}</strong>. Acceptez pour accéder à cette boutique.</Typography.Paragraph><Button type="primary" size="large" icon={<CheckCircleOutlined />} loading={accepting} onClick={accept}>Accepter l’invitation</Button></> : <><Typography.Paragraph>Connectez-vous ou créez votre compte avec l’adresse e-mail qui a reçu cette invitation.</Typography.Paragraph><div className="flex justify-center gap-3"><Link to={`/login?redirect=${redirect}`}><Button type="primary">Se connecter</Button></Link><Link to={`/register?redirect=${redirect}`}><Button>Créer un compte</Button></Link></div></>}</Card></div>;
};

export default TeamInvitation;
